var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paypal"},[_c('div',{staticClass:"paypal-message"},[_c('p',[_vm._v("\n      At this stage you would login using your Paypal username and password to authorise a transaction.\n    ")]),_vm._v(" "),_c('a',{on:{"click":_vm.goToConfirm}},[_vm._v("Click to continue")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b328b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/paypal.vue
// module id = null
// module chunks = 